import React from 'react';
import { Helmet } from 'react-helmet-async';
import QuoteCreator from '../components/QuoteCreator';

const CreateQuotePage = () => {
    const siteUrl = window.location.origin;
    return (
        <div className="page-container">
            <Helmet>
                <title>Create Your Own Quote — Captions</title>
                <meta name="description" content="Replace the first three words of a real inspirational quote with your own. Personalise it, credit it to yourself, and download it as a shareable image card." />
                <link rel="canonical" href={siteUrl + '/create-quote'} />
                <meta property="og:url" content={siteUrl + '/create-quote'} />
                <meta property="og:title" content="Create Your Own Quote — Captions" />
                <meta property="og:description" content="Replace the first three words of a real inspirational quote with your own. Personalise it, credit it to yourself, and download it as a shareable image card." />
            </Helmet>
            <h1>Make It Yours</h1>
            <p className="page-subtitle">Replace the first three words of a real quote with your own.</p>
            <QuoteCreator />
        </div>
    );
};

export default CreateQuotePage;
